import { render, staticRenderFns } from "./notificationCard.vue?vue&type=template&id=10126df2"
import script from "./notificationCard.vue?vue&type=script&lang=js"
export * from "./notificationCard.vue?vue&type=script&lang=js"
import style0 from "./notificationCard.vue?vue&type=style&index=0&id=10126df2&prod&lang=css"
import style1 from "./notificationCard.vue?vue&type=style&index=1&id=10126df2&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports